
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("cookieConsent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .cookie-sheet {
          animation: slideUp 0.45s ease-out;
        }

        @media (max-width: 768px) {
          .cookie-sheet {
            flex-direction: column !important;
            gap: 12px !important;
            padding: 14px 16px 16px !important;
          }

          .cookie-content {
            text-align: center;
          }

          .cookie-actions {
            flex-direction: row !important;
            width: 100%;
            max-width: 100% !important;
          }

          .cookie-btn {
            flex: 1;
            width: auto;
            padding: 12px 10px !important;
          }

          .cookie-handle {
            display: none;
          }
        }
      `}</style>

      <div style={styles.wrapper}>
        <div style={styles.card} className="cookie-sheet">
          <div style={styles.handle} className="cookie-handle" />

          <div style={styles.content} className="cookie-content">
            <h3 style={styles.title}>
              שימוש בעוגיות (Cookies)
            </h3>

            <p style={styles.text}>
              אתר זה עושה שימוש בקובצי Cookies וטכנולוגיות מעקב דומות לצורך
              הפעלה תקינה, שיפור ביצועים, ניתוח שימושים והתאמת חוויית המשתמש.
              אנו עשויים לאסוף מידע אנונימי סטטיסטי לשם שיפור השירותים.
              המשך השימוש באתר מהווה הסכמה לכך.{" "}
              <Link to="/Privacy_Policy" style={styles.link}>
                למדיניות הפרטיות המלאה
              </Link>
            </p>
          </div>

          <div style={styles.actions} className="cookie-actions">
            <button
              className="cookie-btn"
              onClick={() => handleChoice("accepted")}
              style={{ ...styles.button, ...styles.accept }}
            >
              אישור
            </button>

            <button
              className="cookie-btn"
              onClick={() => handleChoice("declined")}
              style={{ ...styles.button, ...styles.decline }}
            >
              סירוב
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2147483647,
    display: "flex",
    justifyContent: "center",
  },

  card: {
    width: "100%",
    maxWidth: "100%",
    background: "#0f172a",
    color: "#fff",
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
    padding: "14px 24px 18px",
    boxShadow: "0 -10px 35px rgba(0,0,0,0.35)",
    direction: "rtl",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
    textAlign: "right",
  },

  handle: {
    display: "none",
  },

  content: {
    flex: 1,
    maxWidth: "850px",
  },

  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "700",
  },

  text: {
    marginTop: "6px",
    marginBottom: 0,
    fontSize: "14px",
    color: "#d1d5db",
    lineHeight: "1.7",
  },

  link: {
    color: "#60a5fa",
    fontWeight: "600",
    textDecoration: "underline",
  },

  actions: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    width: "100%",
    maxWidth: "250px",
    flexDirection: "row",
    flexShrink: 0,
  },

  button: {
    flex: 1,
    border: "none",
    borderRadius: "12px",
    padding: "13px 18px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
  },

  accept: {
    background: "linear-gradient(135deg,#3b82f6,#2563eb)",
    color: "#fff",
  },

  decline: {
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.12)",
  },
};
